module.exports = __webpack_public_path__ + "static/media/photo6@2x.a5bbe38a.jpg";